import React, { Component } from 'react'
import { post } from '../../../utils/networking'
import { NavLink } from 'react-router-dom'
import { get } from '../../../utils/networking'
import TextInput from '../../../textInput'
import $ from 'jquery'
import { isNumber } from 'util';
import * as Notify from '../../../notification'

export default class Reward extends Component {

    constructor(props) {
        super(props)
        this.state = {
            user: {},
            withdrawAddress: "",
            amount: 0
        }
    }
    componentWillMount() {
        get('user/getMyProfile', "customer", result => {
            this.setState({
                user: result.user
            })
        })
    }
    handleWithdraw() {
        Notify.hide();
        let param = {
            addressGcx: this.state.withdrawAddress,
            amount: parseFloat(this.state.amount)
        }
        post("user/withDrawByAccount", param, "customer", result => {

            get('user/getMyProfile', "customer", result => {
                this.setState({
                    user: result.user
                }, () => Notify.show($("#submit-withdraw"), "Withdraw success", "success", "0"))
            })
        }, errors => {
            Notify.show($("#submit-withdraw"), errors.error, "fail", "0")
        })
    }
    render() {
        let {
            user,
            withdrawAddress,
            amount
        } = this.state
        return (
            <div className="rewards">
                <div className="points-sidebar">
                    <fieldset className="points_earned gcx">
                        <legend><span>GCX</span></legend>
                        <p className="points_value">{
                            user.gcxPoint ? user.gcxPoint : 0
                        }</p>
                        <p className="message">GCX COIN</p>
                        <div className="detail">
                            <span>GCX Account: {user.accountGcx}</span>
                            <span className="address">GCX Address: <span>{user.addressGcx}</span></span>
                        </div>
                        <div className="withdraw">
                            <label>Withdraw</label>
                            <TextInput
                                name="withdrawAddress"
                                label="Address"
                                showLabel={true}
                                value={withdrawAddress}
                                onChange={value => this.setState({ withdrawAddress: value })}
                            />
                            <TextInput
                                name="amount"
                                label="Amount"
                                showLabel={true}
                                value={amount}
                                onChange={value => {
                                    if (!isNaN(value))
                                        this.setState({ amount: value })

                                }
                                }
                            />
                            <p>Account balance GCX must be greater than 0.2</p>
                            <div className="submit-withdraw">
                                <span onClick={() => this.handleWithdraw()} id="submit-withdraw">Send</span>
                            </div>
                        </div>
                    </fieldset>
                    {/* <NavLink to="/pages/referral-program" className="back_to_earn" href="#"> Start earning points</NavLink> */}
                </div>
                <div className="points-sidebar">
                    <fieldset className="points_earned">
                        <legend><i className="fa fa-usd" aria-hidden="true"></i></legend>
                        <p className="points_value">{
                            user.personalPoint + user.referalPoint
                        }</p>
                        <p className="message">POINTS EARNED</p>
                        <div className="point-detail">
                            <div className="personal-point">
                                <label>Personal Point</label>
                                <span>{user.personalPoint}</span>
                            </div>
                            <div className="referal-point">
                                <label>Referal Point</label>
                                <span>{user.referalPoint}</span>
                            </div>
                        </div>
                    </fieldset>
                    {/* <div className="progress_round">
                        <div className="level_1">$25</div>
                        <div className="level_2">$50</div>
                        <div className="level_3">$100</div>
                    </div> */}
                    <NavLink to="/pages/referral-program" className="back_to_earn" href="#"> Start earning points</NavLink>
                    {/* <button className="rewards_button">
                        Redeem Your Points
                    </button> */}
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/user/reward/index.js